import {
  oneOfType,
  number,
  string,
} from 'prop-types'

export default oneOfType([number, string])